export default __webpack_public_path__ + "static/media/XEMP-12.26fd7f8a.jpg";